const STORAGE_KEY = 'superAdminSupportAccess';

export interface SuperAdminSimulatedUser {
  id: number;
  first_name: string;
  last_name: string;
  pseudo?: string;
  email?: string;
}

export interface SuperAdminSupportAccess {
  storeId: number;
  storeName: string;
  returnTo: string;
  simulatedUser?: SuperAdminSimulatedUser | null;
}

export function getSupportAccess(): SuperAdminSupportAccess | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SuperAdminSupportAccess;
    if (!parsed?.storeId || !parsed.returnTo) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setSupportAccess(data: SuperAdminSupportAccess): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function clearSupportAccess(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function isSupportAccessActive(): boolean {
  return getSupportAccess() != null;
}

export function simulatedUserLabel(user?: SuperAdminSimulatedUser | null): string | null {
  if (!user) return null;
  const name = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
  return name || user.pseudo || user.email || null;
}

export function supportScopedCacheKey(base: string): string {
  const simulatedId = getSupportAccess()?.simulatedUser?.id;
  return simulatedId ? `${base}_as_${simulatedId}` : base;
}
